
export function falsyToDashesModule(input){
        return !input || input === '0' ? '--' : input;
}